module.exports = __webpack_public_path__ + "img/crew_adv_12.7c64d4af.png";